import React from "react";
import VideoAndAssistance from "./VideoAndAssistance";

const Soccer6Rules = () => {
  return (
    <div>
      <blockquote>
        <p>For as little as R6, Soccer 6 enables soccer fans to use their knowledge of the beautiful game to win big!</p>
      </blockquote>

      <VideoAndAssistance videoId="sAx989hIhwE" />

      <blockquote>
        <p>The record payout for Soccer 6, which launched in 2003, is R233,824.</p>
      </blockquote>
      <div className="panel">
        <p>
          PSL and English Premiership matches form the core of Soccer 6 pools, but games from the French, German, Italian, Portuguese and Spanish leagues are
          utilised, as well as international clashes and matches from UEFA Champions League etc. We strive to offer entertaining and challenging pools that
          contain the best matches sourced from a variety of leagues and competitions.
        </p>
        <p>
          Information about the teams involved in Soccer 6 pools is published on this site and includes one or more of league table and head-to-head form guides
          and comments, previews and tips from our team of experts.
        </p>
      </div>
      <p>
        <strong>PLEASE NOTE:</strong> In Soccer 6 and other TAB soccer bets, the result of a match is the score at the end of the normal 90-minute playing
        period plus any injury time that may be played. Extra time and penalty shootouts are of no account.
      </p>
      <h2>Soccer 6 is easy to play!</h2>
      <div className="panel">
        <p>
          There are six games in a Soccer 6 pool – M1 through M6. To win, you must predict the results of the six matches. In each game, one team is designated
          Team A and the other Team B.
        </p>
        <p>There are 3 results to choose from in each match:</p>
        <ul>
          <li>Team A to Win</li>
          <li>Draw</li>
          <li>Team B to Win</li>
        </ul>
      </div>
      <p>The computerised tote betting system uses numbers to denote the above options:</p>
      <p>
        1 = Win by Team A; 2 = Draw; 3 = Win by Team B. So when you bet by phone or use a betting form, use the numbers 1, 2 and 3 to denote your choices. The
        same numbers are used to display results, while M1 is used to denote Match 1, M2 for Match 2 and so on.
      </p>
      <p>With Soccer 6, you can play a single or multiple entry. With a single entry, you select ONE option or choice for each match and the bet costs R6.</p>
      <p>
        With a multiple entry, you can choose more than one option in one or more matches. The cost is R6 per combination. To calculate the number of
        combinations, multiply out the total number of options or choices for each match. Then take that total and multiply it by 6 to calculate the cost of the
        bet.
      </p>
      <h2>When To Play?</h2>
      <p>
        There are Soccer 6 pools every day. For Saturday or Saturday-Sunday pools, bets can usually be played from Friday until the start of the earliest Soccer
        6 match in the pool.
      </p>
      <p>
        For Monday, Tuesday or Tuesday-Wednesday pools, betting normally opens on Monday mornings. The opening and closing times for betting Soccer 6 is shown
        clearly with each pool published.
      </p>
      <p>The official Soccer 6 payouts are declared as soon as the official results of the matches are received from the governing soccer bodies.</p>
      <div className="panel">
        <h2>Where to Play?</h2>
        <p>
          <strong>ONLINE</strong> on this site, using a PC, tablet or smartphone. Click on REGISTER on the home page, complete the form and SUBMIT. Your account
          will be opened immediately and you can start playing once you have deposited funds.
        </p>
        <p>
          <strong>BY PHONE:</strong> Call 0861 444 822 to open a telephone betting account.
        </p>
        <p>
          <strong>TABs:</strong> At any of over 400 TABs. Call 0861 444 822 to get the address of your nearest TAB (if you live in the Western Cape or
          KwaZulu-Natal, call 0801 314 740). MOBILE www.soccer6.co.za
        </p>
        <p>
          <strong>FNB</strong> customers can use FNB Cellphone Banking to play. FNB customers can register for Cellphone Banking at any FNB branch or FNB ATM or
          via FNB Online Banking at www.fnb.co.za
        </p>
      </div>
      <h2>Key Soccer 6 Information</h2>
      <ul>
        <li>
          On the Soccer 6 bet slip, you must mark S6 and then V1 or V2 and P1 or P2. Which pool to mark or call is always clearly shown when pool details are
          published.
        </li>
        <li>In Soccer 6, the result of a match is the score at the end of the normal 90-minute playing period plus any injury time that may be played.</li>
        <li>It does not include extra time nor penalty shootouts.</li>
        <li>
          {" "}
          Any match in a Soccer 6, 4 or 10 pool not completed by 9am on the day after the last day on which matches in the pool were scheduled, shall be deemed
          abandoned and all choices shall qualify. The times at which matches are completed will be as supplied by the operator's official source,
          notwithstanding the operator's decision in terms of when a match has not been completed shall be final and binding. Further, the operator reserves the
          right to extend the time for a match to be completed if circumstances warrant and provided this does not unduly hamper the declaration of results and
          dividends.
        </li>
        <li>The payout for each Soccer 6 pool is calculated by dividing the number of winning entries into the pool total.</li>
        <li>
          Official Soccer 6 payouts are declared as soon as official results of all the matches are received (normally the day after the last matches in the
          pool).{" "}
        </li>
        <li>Results and payouts are published on this website and displayed at TABs as soon as they become available.</li>
        <li>
          If you have a winning combination, present your ticket and collect your money at any TAB outlet. For telephone betting and online account holders,
          winnings are automatically credited to your account and can be transferred directly into your bank account.
        </li>
      </ul>
    </div>
  );
};

export default Soccer6Rules;
